"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatmapModel = void 0;
var mobx_1 = require("mobx");
var getImpactRange_1 = require("./colorScale/impactRange/getImpactRange");
var getImpactCounts_1 = require("./colorScale/impactRange/getImpactCounts");
var Heatmap_Enums_1 = require("./Heatmap_Enums");
var HeatmapModel = /** @class */ (function () {
    function HeatmapModel() {
        var _this = this;
        this.xAxisHeaders = [];
        this.isLoading = true;
        this.sidebarItems = [];
        this.heatmapData = [];
        this.parentIdHistory = [];
        this.showValues = true;
        this.highlightedCell = null;
        this.refresh = function (data) {
            if (data) {
                _this.createXAxisHeaders();
            }
            _this.isLoading = false;
        };
        this.setOnRowClick = function (onRowClick) {
            if (!!onRowClick)
                _this.onRowClick = onRowClick;
        };
        this.setOnCellClick = function (onCellClick) {
            if (!!onCellClick)
                _this.onCellClick = onCellClick;
        };
        this.setImpactRange = function () {
            var impactCounts = (0, getImpactCounts_1.getImpactCounts)(_this.data);
            _this.impactRange = (0, getImpactRange_1.getImpactRange)(impactCounts);
        };
        this.threeLetterDates = function (index) {
            switch (index) {
                case 1:
                    return "Jan";
                case 2:
                    return "Feb";
                case 3:
                    return "Mar";
                case 4:
                    return "Apr";
                case 5:
                    return "May";
                case 6:
                    return "Jun";
                case 7:
                    return "Jul";
                case 8:
                    return "Aug";
                case 9:
                    return "Sep";
                case 10:
                    return "Oct";
                case 11:
                    return "Nov";
                case 12:
                    return "Dec";
            }
        };
        this.twoNumberYear = function (year) {
            return "".concat(year).slice(-2);
        };
        this.createXAxisLabel = function (month, year) {
            var monthLabel = _this.threeLetterDates(month);
            var yearLabel = _this.twoNumberYear(year);
            return "".concat(monthLabel, " ").concat(yearLabel);
        };
        this.createXAxisItem = function (key, month, year, parent) {
            var item = {};
            item.columnKey = "".concat(key);
            item.label = "".concat(_this.createXAxisLabel(month, year));
            item.parent = parent || null;
            return item;
        };
        this.getFirstRowCellData = function () {
            var firstDataRow = _this.data.heatmapRowData[0];
            var firstRowCells = firstDataRow.cellData;
            return firstRowCells;
        };
        this.createXAxisHeaders = function () {
            if (_this.data) {
                _this.xAxisHeaders = [];
                var firstRowCells = _this.getFirstRowCellData();
                firstRowCells.forEach(function (e, i) {
                    var item = _this.createXAxisItem(i, e.month, e.year);
                    _this.xAxisHeaders.push(item);
                });
            }
        };
        this.createYAxisItem = function (key, label, hasChildren, rowId, isParentRow, className) {
            var item = {};
            item.rowKey = key;
            item.label = label;
            item.hasChildren = hasChildren;
            item.rowId = rowId;
            item.isParentRow = isParentRow;
            item.className = className ? className : "";
            return item;
        };
        this.totalsYAxisLabel = function (parentName) {
            var parent = "".concat(parentName, " ");
            if (parentName === null || parentName === undefined)
                parent = "";
            return "".concat(parent, "Totals");
        };
        this.setTotalsYAxisItem = function (data) {
            var totalsItem;
            var key = Heatmap_Enums_1.Rows.Totals;
            var label = ""; //"Unique Impacts";
            var hasChildren = false;
            var rowId = +Heatmap_Enums_1.Rows.Totals;
            totalsItem = _this.createYAxisItem(key, label, hasChildren, rowId, false);
            return totalsItem;
        };
        this.setParentYAxisItem = function (data) {
            var parentItem;
            var key = Heatmap_Enums_1.Rows.Parent;
            var label = "".concat(data.rowName, " (Parent)");
            var hasChildren = false;
            var rowId = _this.parentId;
            parentItem = _this.createYAxisItem(key, label, hasChildren, rowId, true);
            return parentItem;
        };
        this.sortRowData = function (data) {
            var parentIndex = data.findIndex(function (e) { return e.isParentRow === true; });
            var parentRow;
            if (_this.parentId !== 0)
                parentRow = data.splice(parentIndex, 1)[0];
            if (_this.parentId !== 0)
                data.splice(0, 0, parentRow);
            return data;
        };
        this.setYAxisItems = function (data) {
            var YAxisItems = [];
            var totalsItem = _this.setTotalsYAxisItem(data);
            YAxisItems.push(totalsItem);
            var sortedRowData = _this.sortRowData(data.heatmapRowData);
            sortedRowData.forEach(function (e, i) {
                var item;
                if (e.isParentRow)
                    item = _this.setParentYAxisItem(e);
                else {
                    var key = "".concat(i);
                    var label = e.rowName;
                    var hasChildren = e.childCount > 0;
                    var rowId = e.rowId;
                    item = _this.createYAxisItem(key, label, hasChildren, rowId, false);
                }
                YAxisItems.push(item);
            });
            return YAxisItems;
        };
        this.setDataValueItem = function (key, xAxisKey, yAxisKey, value, rowId, className) {
            var setClassName = className ? className : "";
            var item = {};
            item.key = key;
            item.yAxisKey = yAxisKey;
            item.xAxisKey = xAxisKey;
            item.value = value;
            item.rowId = rowId;
            item.className = setClassName;
            return item;
        };
        this.getCellValue = function (element) {
            if (element.count || element.count === 0)
                return element.count;
            return element;
        };
        this.createRowData = function (cellsData, yKey, rowDataId) {
            var result = [];
            cellsData.forEach(function (e, i) {
                var xAxisKey = "".concat(i);
                var yAxisKey = "".concat(yKey);
                var key = "".concat(yAxisKey, "_").concat(xAxisKey, "_").concat(i);
                var value = _this.getCellValue(e);
                var rowId = rowDataId;
                var item = _this.setDataValueItem(key, xAxisKey, yAxisKey, value, rowId);
                result.push(item);
            });
            return result;
        };
        this.createTotalsDataRow = function (data) {
            return _this.createRowData(data.totalImpactCountByMonth, Heatmap_Enums_1.Rows.Totals, +Heatmap_Enums_1.Rows.Totals);
        };
        this.createAllDataRows = function (data) {
            var result = [];
            data.heatmapRowData.forEach(function (e, i) {
                var yKey = e.isParentRow ? Heatmap_Enums_1.Rows.Parent : i;
                var dataValueItems = _this.createRowData(e.cellData, yKey, e.rowId);
                result = result.concat(dataValueItems);
            });
            return result;
        };
        this.heatmapDataGenerator = function (data) {
            _this.rowLength = data.heatmapRowData[0].cellData.length;
            var totalsRow = _this.createTotalsDataRow(data);
            var dataRows = _this.createAllDataRows(data);
            var allRows = totalsRow.concat(dataRows);
            _this.heatmapData = allRows;
        };
        this.addParentIdToHistory = function (id) {
            _this.parentIdHistory.push(id);
        };
        this.removeParentIdFromHistory = function () {
            _this.parentIdHistory.pop();
        };
        this.getPreviousParentId = function () {
            var parentIdHistory = _this.parentIdHistory;
            var lastHistoryEntry = parentIdHistory.slice(-1);
            var previousParentId = lastHistoryEntry[0];
            return previousParentId;
        };
        this.setParentNameAndId = function (data) {
            _this.parentId = data.parentId;
            _this.parentName = data.parentName;
        };
        this.setData = function (data) {
            if (data.heatmapRowData.length > 0) {
                _this.data = data;
                _this.setParentNameAndId(data);
                _this.sidebarItems = _this.setYAxisItems(data);
                _this.heatmapDataGenerator(data);
                _this.refresh(data);
            }
        };
        this.setShowValues = function (showValues) {
            _this.showValues = showValues;
        };
        this.getCellMonth = function (index) {
            var firstRowCells = _this.getFirstRowCellData();
            return firstRowCells[index].month;
        };
        this.getCellYear = function (index) {
            var firstRowCells = _this.getFirstRowCellData();
            return firstRowCells[index].year;
        };
        this.onMount = function () { };
        this.onUnmount = function () { };
    }
    __decorate([
        mobx_1.observable
    ], HeatmapModel.prototype, "isLoading", void 0);
    __decorate([
        mobx_1.observable.ref
    ], HeatmapModel.prototype, "parentId", void 0);
    __decorate([
        mobx_1.observable.ref
    ], HeatmapModel.prototype, "parentIdHistory", void 0);
    __decorate([
        mobx_1.observable.ref
    ], HeatmapModel.prototype, "showValues", void 0);
    __decorate([
        mobx_1.observable.ref
    ], HeatmapModel.prototype, "data", void 0);
    __decorate([
        mobx_1.observable.ref
    ], HeatmapModel.prototype, "highlightedCell", void 0);
    __decorate([
        mobx_1.observable
    ], HeatmapModel.prototype, "impactRange", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "refresh", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "setOnRowClick", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "setOnCellClick", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "createXAxisHeaders", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "createYAxisItem", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "setTotalsYAxisItem", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "setYAxisItems", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "createRowData", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "createTotalsDataRow", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "createAllDataRows", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "heatmapDataGenerator", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "addParentIdToHistory", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "removeParentIdFromHistory", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "setParentNameAndId", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "setData", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "setShowValues", void 0);
    __decorate([
        mobx_1.action
    ], HeatmapModel.prototype, "onMount", void 0);
    return HeatmapModel;
}());
exports.HeatmapModel = HeatmapModel;
